
export function downloadPdf(blob, fileName) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function printPDF(data) {
  try {
    const blobUrl = URL.createObjectURL(data);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
          <html>
            <head>
              <title>Print PDF</title>
              <link rel="icon" type="image/x-icon" href="/iconnagamas.ico" />
              <style>
                html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${blobUrl}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function () {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);

    printWindow.document.close();
  } catch (error) {
    console.error("Failed to load or print PDF Blob:", error);
  }
};
